export default __webpack_public_path__ + "9bec0bf9f27c53b2dfc7e0e9462a30df.jpg";